<template>
  <div class="map-container">
    <p class="text-right">
      <span
        class="btn btn-primary"
        @click="e => $emit('closeMap', { e: e, v: false })"
      >
        <i class="fas fa-times"></i>
      </span>
    </p>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2539.888309990433!2d-106.65878978408824!3d50.46180449442737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x531a13562fa99553%3A0xc896274c645345da!2sRM%20of%20CHAPLIN%20No.%20164!5e0!3m2!1sen!2sca!4v1593371163346!5m2!1sen!2sca"
      width="400"
      height="300"
      frameborder="0"
      style="border:0;"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Map",
  data: () => ({})
};
</script>

<style lang="scss">
.map-container {
  padding: 0.5rem;
  background-color: #fff;
  border: solid 1px #666;
  border-radius: 3px;
  z-index: 99;
}

iframe {
  border: none !important;
  outline: none !important;
}
</style>
